import { FilterAlt } from "@mui/icons-material"
import { IconButton, IconButtonProps } from "@mui/material"
import { FC } from "react"

export const HomeFilterButton: FC<IconButtonProps> = (props) => {
    return (
        <IconButton size="small" {...props}>
            <FilterAlt fontSize="small" />
        </IconButton>
    )
}